/*
 * @Author       : lilb-b
 * @Date         : 2022-09-21 09:34:12
 * @LastEditTime: 2022-09-29 14:16:06
 * @LastEditors: GRANDSOFT\hej-n
 * @Description  :
 * @FilePath: \fe_spa_joint_procurement\src\utils\request-test.js
 */
import axios from "axios";
import { ElMessage as Message } from "element-plus";
import router from "@/router/index";

let codes = [200];
const instance = axios.create({
  withCredentials: true,
  // baseURL: '/api1',
  timeout: 30000,
});
instance.interceptors.request.use(
  (config) => {
    if (!config.url.endsWith("/login")) {
      config.headers["token"] = localStorage.getItem("token") || "";
    }
    // 自定义返回状态码
    if (config.codes) {
      codes = config.codes;
    } else {
      codes = [200];
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

instance.interceptors.response.use(
  (res) => {
    if (
      res.data.statusCode === 101 ||
      res.data.statusCode == 102 ||
      res.data.status === 101 ||
      res.data.status == 102
    ) {
      Message.error(res.data.message);
      router.push({
        name: "Login",
      });
      return;
    } else if (codes.indexOf(res.data.statusCode || res.data.status) > -1) {
      return res.data;
    } else if (res.request.getResponseHeader("Content-Disposition")) {
      return res;
    }
    Message.error(res.data.message || "失败，后台未返回错误信息！");
    return Promise.reject(res.data.message);
  },
  (err) => {
    Message.error("请求错误" + err);
    return Promise.reject(err);
  }
);
instance.interceptors.request.use(
  (config) => {
    if (config.method.toLocaleLowerCase() === "post") {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/*******
 * @description: 注意，不需要传method。默认是get请求，如果是get请求，只需传params，如果是post请求，只需传data即可。
 * @param {} param1
 * @return {}
 */
async function request({ url, data, params, cb, err, codes }) {
  let obj = {
    url,
    method: "get",
    codes,
  };
  if (data) {
    obj = { ...obj, data, method: "post" };
  } else {
    obj = { ...obj, params };
  }

  try {
    const res = await instance(obj);
    if (res.statusCode === 200) {
      cb && cb(res.data);
    } else {
      err && err();
    }
  } catch {
    err && err();
  }
}
export default request;
